import React, { useMemo } from 'react';
import cn from 'classnames';
import HorizontalBarChart from '../../charts/HorizontalBarChart/HorizontalBarChart';
import { horizontalChartPlaceholderType } from '../../../constants/common';
import styles from '../chartsPlaceholder.module.scss';

const HorizontalBarChartPlaceholder = ({
  title,
  className,
  outlined,
  type = horizontalChartPlaceholderType.EXECUTER,
  placeholderText = 'Данных нет',
  style,
}) => {
  const data = useMemo(
    () =>
      new Array(3)
        .fill('')
        .map((_el, index) => {
          return {
            name: type + ' ' + (index + 1),
            value: Math.floor(Math.random() * 10) + 1,
          };
        })
        .sort((left, right) => right.value - left.value),
    [type]
  );
  return (
    <div className={cn(className, styles.container)} style={style}>
      <HorizontalBarChart
        colors={['#DED9D9']}
        title={title}
        data={data}
        className={styles.placeholderContainer}
        outlined={outlined}
      />
      <div className={styles.placeholder}>{placeholderText}</div>
    </div>
  );
};

export default HorizontalBarChartPlaceholder;
